export default __webpack_public_path__ + "static/media/questionWhite.9b3e1d92.svg";